<template>
  <card
    :headerClasses="headerColor"
    class="no-border-card"
    body-classes="px-0 pb-1"
    footer-classes="pb-2"
  >
    <b-row v-if="false" class="mt-0" align-v="center" slot="header">
      <h3 class="mb-0 mt-0 text-white">{{ title }}</h3>
    </b-row>

    <el-table
      show-summary
      :summary-method="getSummaries"
      :data="data"
      height="360"
      style="width: 100%"
      :cell-style="{ padding: '8px' }"
    >
      <el-table-column
        v-for="column in tableColumns"
        :key="column.label"
        v-bind="column"
      >
      </el-table-column>
    </el-table>
  </card>
</template>

<script>
import { Table, TableColumn, Select, Option, Form, FormItem } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components'
import { mapGetters, mapActions } from 'vuex'
// import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";

export default {
  name: 'TableInputByPaymentMethod',

  // mixins: [clientPaginationMixin],

  components: {
    BasePagination,
    RouteBreadCrumb,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  props: {
    title: {
      type: String,
    },

    headerColor: {
      type: String,
    },

    data: {
      type: Array | Object,
      default: () => {},
    },
  },

  data() {
    return {
      expandRowKeys: [],
      sumsTotalRows: 0,
      tableColumns: [
        {
          prop: 'paymentMethod',
          label: 'Método de pagamento',
          formatter: (row, col, cell, index) =>
            this.formatterPaymentMethod(row),
          sortable: true,
        },
        {
          prop: 'total',
          label: 'Valor',
          formatter: (row, col, cell, index) => this.formatterMoeda(row),
          sortable: true,
        },
        {
          prop: 'percent',
          label: 'participação (%)',
          formatter: (row, col, cell, index) => this.percenterFromTotal(row),
          sortable: true,
        },
      ],
      // tableData: this.data,
      selectedRows: [],
    }
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
    }),
  },

  watch: {
    // data(newValue, oldValue) {
    //   this.tableData = newValue;
    // }
  },

  methods: {
    percenterFromTotal(row) {
      if (this.sumsTotalRows > 0) {
        let percent = (row.value / this.sumsTotalRows) * 100
        return percent.toFixed(2) + '%'
      }
      return 0
    },

    formatterMoeda(row) {
      return row.value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },

    formatterPaymentMethod(row) {
      return row.label
    },

    getSummaries(param) {
      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total'
          return
        }
        if (index == columns.length - 1) {
          sums[index] = '100%'
          return
        }

        const values = data.map((item) => Number(item.value))

        if (!values.every((value) => isNaN(value))) {
          let sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)

          sums[index] = sum.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          this.sumsTotalRows = sum
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    handleExpandChange(row, expandedRows) {
      const id = row.id
      const lastId = this.expandRowKeys[0]
      // disable mutiple row expanded
      this.expandRowKeys = id === lastId ? [] : [id]
    },
  },

  mounted() {
    // this.createFuseSearch(["name", "position", "date"]);
  },
}
</script>

<style scoped>
@import url('//unpkg.com/element-ui@2.4.11/lib/theme-chalk/index.css');

.card .table td,
.card .table th,
.card .el-table td,
.card .el-table th {
  padding-left: 1rem;
  padding-right: 1rem;
}

.card {
  box-shadow: none;
  -webkit-box-shadow: none;
}

.expand-content {
  margin-left: 40px;
}
</style>
